// extracted by mini-css-extract-plugin
export default {"container":"intro_container__YyHD+","content":"intro_content__EHuBP","leftContent":"intro_leftContent__iZsMl","rightContent":"intro_rightContent__mvQRI"};